import styled from 'styled-components';
const DropdownContainer = styled.div.withConfig({
  displayName: "DropdownContainer",
  componentId: "sc-kxe7te-0"
})(["width:100%;"]);
DropdownContainer.displayName = 'Dropdown.Container';
export default DropdownContainer;